import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  Output,
  ViewChild,
} from '@angular/core';
import {ReactBaseComponent} from '../../../../react/base/react-base.component';
import {BigFetchWithCleanPosition} from './fetch-box.model';
import {FetchBoxHeader} from '../../../../react/fetch/box-header/fetch-box-header';
import {FetchStatusChange} from '../../../../react/fetch/status-change/fetch-status-change';
import {ErpAlertContext} from '../../../../react/components/react-angular-alert/erp-react-alert-context';
import {
  ErpAngularZonedAlertService,
} from '../../../../react/components/react-angular-alert/erp-angular-zoned-alert.service';
import {RightService} from '../../../../common/right-service/right.service';

const containerElementName = 'reactFetchBoxHeader';

@Component({
  selector: 'fetch-box-header',
  template: `<div #${containerElementName}></div>`,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class FetchBoxHeaderComponent extends ReactBaseComponent {
  @ViewChild(containerElementName, {static: false}) containerRef: ElementRef;
  @Input() workflowId: number;
  @Input() fetch: BigFetchWithCleanPosition;
  @Output() statusChanged: EventEmitter<number> = new EventEmitter<number>();

  constructor(private ngZone: NgZone,
              private rightService: RightService,
              private alertService: ErpAngularZonedAlertService) {
    super();
  }

  statusChange(status: number): void {
    this.ngZone.run(() => {
      this.statusChanged.emit(status);
    });
    this.render();
  }

  protected override renderComponent() {
    return <ErpAlertContext.Provider value={{context: this.alertService.context()}}>
      <FetchBoxHeader fetch={this.fetch}>
        <FetchStatusChange workflowId={this.workflowId}
                           fetch={this.fetch}
                           hasStatusChangeRight={this.rightService.has('fetch.change.status')}
                           hasConcludedNotBilledRight={
                             this.rightService.has('fetch.change.status.concluded_not_billed')
                           }
                           statusChanged={status => this.statusChange(status)}/>
      </FetchBoxHeader>
    </ErpAlertContext.Provider>;
  }
}
